//import { motion } from "framer-motion";

import classNames from "classnames";
import classes from "./header.module.scss";

import { FaBars, FaTimes } from "react-icons/fa";
function Header({ clickMobile, onClickLogo, onClickMobile }) {
  return (
    <div className={classNames(classes.header)}>
      <img
        src={"/images/header/PROSSIMITI-logo.svg"}
        alt="Logo"
        onClick={onClickLogo}
        className={classes.logo}
      />
      {clickMobile ? (
        <FaTimes size="2rem" onClick={onClickMobile()} />
      ) : (
        <FaBars size="2rem" onClick={onClickMobile()} />
      )}
    </div>
  );
}

export default Header;
